var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 0.5H8C3.58172 0.5 0 4.08172 0 8.5V46.5C0 50.9183 3.58172 54.5 8 54.5H46C50.4183 54.5 54 50.9183 54 46.5V8.5C54 4.08172 50.4183 0.5 46 0.5Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1666 31.625L30.6666 27.5L25.1666 23.375V31.625ZM27 18.3333C21.94 18.3333 17.8333 22.44 17.8333 27.5C17.8333 32.56 21.94 36.6666 27 36.6666C32.06 36.6666 36.1666 32.56 36.1666 27.5C36.1666 22.44 32.06 18.3333 27 18.3333ZM27 34.8333C22.9575 34.8333 19.6666 31.5425 19.6666 27.5C19.6666 23.4575 22.9575 20.1666 27 20.1666C31.0425 20.1666 34.3333 23.4575 34.3333 27.5C34.3333 31.5425 31.0425 34.8333 27 34.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybutton);
export default __webpack_public_path__ + "static/media/playbutton.9493df4d29feedbfb36d8a4879219c65.svg";
export { ForwardRef as ReactComponent };